import { Navigate, Outlet } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import {
	PortalCentered,
	PortalLoading,
	portalButtonOutline,
	portalPanel,
} from '@/routes/appointments/portal-shell'
import { trpc } from '@/trpc/client'

/**
 * Layout route guarding the public patient portal pages.
 * Session lives in an HttpOnly cookie, so presence is checked by asking the
 * server (patientPortal.me). Only an actual UNAUTHORIZED redirects to the
 * patient login — a transient network/server error shows a retry state
 * instead of silently bouncing a logged-in patient.
 */
export function RequirePatientAuth() {
	const {
		data: me,
		isLoading,
		isError,
		error,
		refetch,
	} = trpc.patientPortal.me.useQuery(undefined, {
		retry: false,
	})

	if (isLoading) {
		return <PortalLoading />
	}

	if (isError && error.data?.code !== 'UNAUTHORIZED') {
		return (
			<PortalCentered>
				<div
					className={`${portalPanel} w-full max-w-md space-y-4 p-8 text-center`}
				>
					<p className="text-[#242424]">
						Nepodařilo se ověřit přihlášení. Zkuste to prosím znovu.
					</p>
					<Button className={portalButtonOutline} onClick={() => refetch()}>
						Zkusit znovu
					</Button>
				</div>
			</PortalCentered>
		)
	}

	if (!me) {
		return <Navigate to="/appointments/login" replace />
	}

	return <Outlet />
}
